import React, {useEffect, useState, useCallback} from 'react';
import {View, Text, TouchableOpacity} from 'react-native';
import Entypo from 'react-native-vector-icons/Entypo';
import {Colors} from '../../../../constants/Colors';
import ButtonComponent from '../../../../components/ButtonComponent/ButtonComponent';
import {styles} from './styles';

import { useNavigation } from '@react-navigation/native';
import { NavigationProps } from '../../../../navigation/Routes';
import { AppRoutes } from '../../../../navigation/Routes.types';
import {useBagStore} from '../../../../store/BagStore';

interface ICounter {
  width?: string;
  height?: number;
  mt?: number;
  directionButton?: string;
  buttonWidth?: string;
  hasButton?: boolean;
  hasRanges?: boolean;
  hasMoreFive?: boolean;
  quantity?: number;
  counterPosition?: string;
  max?: number;
  onPress?: (val: number) => void;
  increment?: (count: number) => void;
  decrement?: (count: number) => void;
  item?: Object;
}

const Counter = React.memo(
  ({
    width = '100%',
    height = 30,
    mt = 20,
    directionButton,
    buttonWidth = '100%',
    hasButton = true,
    counterPosition = 'center',
    onPress,
    quantity,
    increment,
    decrement,
    hasRanges = false,
    hasMoreFive = false,
    max,
    item,
  }: ICounter) => {
    const [count, setCount] = useState<number>(quantity || 0);
    const [isAdded, setIsAdded] = useState<boolean>(false);
    const [initialCount, setInitialCount] = useState<number>(quantity || 0);
    const products = useBagStore(state => state.products);
    const [isInCart, setIsInCart] = useState<boolean>((products.find(prod => prod.sku === item?.sku)?.quantity || 0) > 0);
    
    const { navigate } = useNavigation<NavigationProps>();

    useEffect(() => {
      setCount(quantity || 0);
      setInitialCount(quantity || 0);
      setIsInCart((products.find(prod => prod.sku === item?.sku)?.quantity || 0) > 0);
    }, [quantity, products]);

    const handleAdd = useCallback(() => {
      onPress && onPress(count);
      setIsAdded(true);
    }, [count, onPress]);

    const handleUpdate = useCallback(() => {
      onPress(count);
      setIsAdded(true);
    }, [count, onPress]);

    // const handleIncrement = useCallback(() => {
    //   if (max === undefined || count < max) {
    //     setCount(count + 1);
    //     increment && increment(count + 1);
    //     setIsAdded(false);
    //   }
    // }, [count, increment, max]);

    const handleIncrement = useCallback(
      value => {
        if (max === undefined || count + value <= max) {
          setCount(count + value);
          if (value) {
            increment && increment(count + value);
          } else {
            increment && increment(count + 1);
          }
          setIsAdded(false);
        }
      },
      [count, increment, max],
    );

    const handleDecrement = useCallback(() => {
      if (count > 0) {
        setCount(count - 1);
        decrement && decrement(count - 1);
        setIsAdded(false);
      }
    }, [count, decrement]);
    return (
      <View
        style={{
          ...styles.space,
          alignItems: counterPosition,
          flexDirection: directionButton,
        }}>
        <View
          style={{
            ...styles.container,
            width: width,
            height: height,
            marginTop: mt,
          }}>
          <TouchableOpacity onPress={handleDecrement}>
            <Entypo name="minus" size={20} color={Colors.RedPallete.red} />
          </TouchableOpacity>
          <Text
            style={styles.count}
            onPress={() => {
              navigate(AppRoutes.PRODUCT_DETAILS, {item: item});
            }}
          >
            {count}
          </Text>
          <TouchableOpacity
            onPress={count === max ? () => {} : () => handleIncrement(1)}
            disabled={count === max}>
            <Entypo
              name="plus"
              size={20}
              color={count === max ? 'gray' : Colors.RedPallete.red}
            />
          </TouchableOpacity>
        </View>
        
        {hasButton && (
          <>
            {isInCart && count === initialCount && count !== 0 ? (
              <ButtonComponent
                title="Adicionado"
                width={buttonWidth}
                onPress={() => {}}
                backgroundColor="#21ce2f"
              />
            ) : isInCart ? (
              <ButtonComponent
                title="Atualizar"
                width={buttonWidth}
                onPress={handleUpdate}
                backgroundColor="#1f77ec"
              />
            ) : (
              <ButtonComponent
                title="Adicionar"
                width={buttonWidth}
                onPress={handleAdd}
              />
            )}
          </>
        )}
      </View>
    );
  },
);

export default Counter;
